import { merchantApi } from '@/config/axios'

export interface O2oStoreMerchantPageReqVO {
  pageNo: number
  pageSize: number
  name?: string
  city?: string
  status?: number
}

export interface O2oStoreMerchantSaveReqVO {
  id?: number
  name: string
  phone?: string
  province: string
  city: string
  district?: string
  address: string
  coverImage?: string
  longitude?: number
  latitude?: number
  serviceRadiusKm?: number
  businessHours?: string
  serviceCategoryIds?: string
  sort?: number
  status: number
}

export interface O2oStoreMerchantRespVO {
  id: number
  name: string
  phone?: string
  province?: string
  city?: string
  district?: string
  address?: string
  coverImage?: string
  longitude?: number
  latitude?: number
  serviceRadiusKm?: number
  businessHours?: string
  serviceCategoryIds?: string
  sort?: number
  status: number
  createTime?: string
}

export function getO2oMerchantStorePage(params: O2oStoreMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oStoreMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/store/page',
    params
  })
}

export function getO2oMerchantStore(id: number) {
  return merchantApi.get<O2oStoreMerchantRespVO>({
    url: '/merchant-api/o2o/store/get',
    params: { id }
  })
}

export function createO2oMerchantStore(data: O2oStoreMerchantSaveReqVO) {
  return merchantApi.post<number>({
    url: '/merchant-api/o2o/store/create',
    data
  })
}

export function updateO2oMerchantStore(data: O2oStoreMerchantSaveReqVO) {
  return merchantApi.put<boolean>({
    url: '/merchant-api/o2o/store/update',
    data
  })
}

export function deleteO2oMerchantStore(id: number) {
  return merchantApi.delete<boolean>({
    url: '/merchant-api/o2o/store/delete',
    params: { id }
  })
}
